import {Component, Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'not-authenticated-dialog',
  templateUrl: './not_authenticated.html',
  styleUrls: [ './not_authenticated.css' ],
})

export class NotAuthenticatedDialog {

  constructor(
    public dialogRef: MatDialogRef<NotAuthenticatedDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }


  close(){
  	this.dialogRef.close();
  }

}